import { t } from "@lingui/core/macro";

export const buildDisplayName = (params: {
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}): string => {
  const { fullName, firstName, lastName } = params;
  const normalizedFullName = fullName?.trim();
  if (normalizedFullName) {
    return normalizedFullName;
  }

  const composedName = [firstName, lastName]
    .map((namePart) => namePart?.trim())
    .join(" ")
    .trim();

  return composedName || t`Guest`;
};

export const areIdSetsEqual = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) {
    return false;
  }
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((value, index) => value === sortedB[index]);
};
